import type { FLAGS } from 'constants/flags';
import { useFeatureFlags } from 'context/feature-flags/FeatureFlagsContext';

export function useFeature<FlagValueType = boolean>(
  featureFlag: FLAGS,
): [FlagValueType, boolean] {
  const { flags, loaded } = useFeatureFlags();
  return [flags[featureFlag] as FlagValueType, !loaded];
}
